import { Link } from 'react-router-dom';
import { SITE_CONTACTS } from './Header';
import { useAuth } from '../AuthContext';
import { openCookiePreferences } from '../utils/cookieConsent';
import logo from '../../img/logo.webp';
import '../../css/SiteLayout.css';

export default function Footer() {
    const { isAuthenticated } = useAuth();
    return (
        <footer className="ef-footer">
            <div className="ef-footer__inner">
                <div className="ef-footer__top">
                <div className="ef-footer__main">
                    <Link className="ef-footer__brand" to="/" aria-label="Easy Funeral, pagina iniziale">
                        <img className="ef-footer__brand-mark" src={logo} alt="" width="52" height="52" />
                        <span>Easy Funeral</span>
                    </Link>
                    <p>Il ponte tra famiglie e agenzie funebri di qualità in tutta Italia.</p>
                </div>

                <section className="ef-footer__agency" aria-labelledby="footer-agency-title">
                    <h2 id="footer-agency-title">{isAuthenticated ? 'La tua area riservata' : 'Area agenzie'}</h2>
                    <p>{isAuthenticated ? 'Tutto ciò che serve per gestire la tua presenza su Easy Funeral.' : 'Uno spazio dedicato alle onoranze funebri della nostra rete.'}</p>
                    <nav className="ef-footer__agency-actions" aria-label="Area agenzie">
                        {isAuthenticated ? <Link className="ef-footer__agency-access" to="/profilo">Vai al tuo profilo <span aria-hidden="true">→</span></Link> : <>
                            <Link className="ef-footer__agency-access" to="/login">Accedi</Link>
                            <Link className="ef-footer__agency-register" to="/registrazione">Registra la tua agenzia <span aria-hidden="true">↗</span></Link>
                        </>}
                    </nav>
                </section>
                </div>

                <div className="ef-footer__bottom">
                    <p>© {new Date().getFullYear()} {SITE_CONTACTS.companyName} · P.IVA {SITE_CONTACTS.vatNumber} · Capitale sociale {SITE_CONTACTS.shareCapital}{SITE_CONTACTS.capitalPaidStatus && ` ${SITE_CONTACTS.capitalPaidStatus}`}</p>
                    <div className="ef-footer__legal-links">
                        <Link to="/informazioni-legali">Informazioni legali</Link>
                        <Link to="/condizioni-agenzie">Condizioni agenzie</Link>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <Link to="/cookie-policy">Cookie Policy</Link>
                        <button type="button" onClick={openCookiePreferences}>Preferenze cookie</button>
                    </div>
                </div>
            </div>
        </footer>
    );
}
